/*
    Viewport-aware tooltip positioning for .vk-info elements.
    Detects when a tooltip would overflow the viewport and repositions it
    (bottom, left, or right) by adding a modifier class.
*/

jQuery(document).ready(function(){
    var PLACEMENT_CLASSES = 'vk-info--bottom vk-info--left vk-info--right';
    var EDGE_MARGIN = 8; // px buffer from viewport edge

    jQuery('body').on('mouseenter', '.vk-info', function(){
        var $info = jQuery(this);
        var $tooltip = $info.find('.vk-tooltip');

        if (!$tooltip.length) {
            return;
        }

        // Remove any previous placement class
        $info.removeClass(PLACEMENT_CLASSES);

        // Temporarily show tooltip off-screen to measure its size
        $tooltip.css({ display: 'block', visibility: 'hidden' });
        var tooltipRect = $tooltip[0].getBoundingClientRect();
        var infoRect = $info[0].getBoundingClientRect();
        $tooltip.css({ display: '', visibility: '' });

        var viewportW = window.innerWidth;
        var viewportH = window.innerHeight;

        // Check if default (top) placement overflows
        var overflowTop    = tooltipRect.top < EDGE_MARGIN;
        var overflowBottom = tooltipRect.bottom > viewportH - EDGE_MARGIN;
        var overflowLeft   = tooltipRect.left < EDGE_MARGIN;
        var overflowRight  = tooltipRect.right > viewportW - EDGE_MARGIN;

        if (overflowTop) {
            // Try bottom placement
            var bottomSpace = viewportH - infoRect.bottom;
            if (bottomSpace >= tooltipRect.height + EDGE_MARGIN) {
                $info.addClass('vk-info--bottom');
            } else if (!overflowRight && infoRect.left + tooltipRect.width < viewportW - EDGE_MARGIN) {
                $info.addClass('vk-info--right');
            } else {
                $info.addClass('vk-info--left');
            }
        } else if (overflowLeft || overflowRight) {
            if (overflowRight && !overflowLeft) {
                // Tooltip extends past right edge — try left placement
                $info.addClass('vk-info--left');
            } else if (overflowLeft && !overflowRight) {
                // Tooltip extends past left edge — try right placement
                $info.addClass('vk-info--right');
            }
            // If both sides overflow, keep default (top centered)
        }
        // else: default top placement is fine, no class needed

    }).on('mouseleave', '.vk-info', function(){
        jQuery(this).removeClass(PLACEMENT_CLASSES);
    });
});

/*
    Show tooltips on elements that have class "vk-tooltip-trigger"
*/

jQuery(document).ready(function(){
    jQuery('body').on('mouseenter', '.vk-tooltip-trigger', function(){
        var element = this;
        var text = jQuery(element).data('vktooltip');
        if(text.length > 5){
            var window_width = jQuery(window).width();
            var body_top = jQuery('body').offset().top;
            var position = jQuery(element).offset();
            var top = position.top - body_top;
            var class_name = 'right';
            if(window_width - 250 < position.left){
                class_name = 'left';
                right = window_width - position.left;
                var style = {top:top+'px', right:right+'px', display:'none'};
            }else{
                var style = {top:top+'px', left:position.left+'px', display:'none'};
            }
            var attr = {
                class: class_name
            };
            
            element.vk_tooltip = jQuery('<div class="vk-tooltip">'+text+'</div>').css(style).addClass(class_name);
            jQuery('body').append(element.vk_tooltip);
            jQuery(element.vk_tooltip).fadeIn(250);
        }
    }).on('mouseleave', '.vk-tooltip-trigger', function(){
        var element = this;
        if(element.vk_tooltip){
            jQuery(element.vk_tooltip).fadeOut(250, function(){
                jQuery(this).remove();
            });
            element.vk_tooltip = false;
        }
    });
});